import { useParams } from 'react-router-dom';
import { extractMerchantSlugFromUrl } from 'utils/url';

function useMerchantIdOrSlug() {
  const { merchantId } = useParams();

  return merchantId || extractMerchantSlugFromUrl();
}

export default useMerchantIdOrSlug;
